import React, { Component } from "react";
// 图标
import SunImg from "images/report/sun.png";
import MoonImg from "images/report/moon.png";
import MountainImg from "images/report/mountain.png";
import PentagonImg from "images/report/pentagon.png";
import TriangleImg from "images/report/triangle.png";
import RectangleImg from "images/report/rectangle.png";
import SnowImg from "images/report/snow.png";
import WaterImg from "images/report/water.png";

function App(props) {
    const { data, i18n } = props;

    return (
        <div className="report-table">
            {/* <div className="report-table-title">情绪评分总结</div> */}
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.angry}</div>
                        <div className="report-table-td-subtitle">{i18n.report.angry}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-sun-big" src={SunImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.angryInfo1}</p>
                        <p className="report-text">{i18n.report.angryInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.happines}</div>
                        <div className="report-table-td-subtitle">{i18n.report.happines}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-moon-big" src={MoonImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.happinesInfo1}</p>
                        <p className="report-text">{i18n.report.happinesInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.fear}</div>
                        <div className="report-table-td-subtitle">{i18n.report.fear}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-mountain-big" src={MountainImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.fearInfo1}</p>
                        <p className="report-text">{i18n.report.fearInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.disgust}</div>
                        <div className="report-table-td-subtitle">{i18n.report.disgust}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-pentagon-big" src={PentagonImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.disgustInfo1}</p>
                        <p className="report-text">{i18n.report.disgustInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.contempt}</div>
                        <div className="report-table-td-subtitle">{i18n.report.contempt}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-triangle-big" src={TriangleImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.contemptInfo1}</p>
                        <p className="report-text">{i18n.report.contemptInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.neutral}</div>
                        <div className="report-table-td-subtitle">{i18n.report.neutral}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-rectangle-big" src={RectangleImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.neutralInfo1}</p>
                        <p className="report-text">{i18n.report.neutralInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.surprise}</div>
                        <div className="report-table-td-subtitle">{i18n.report.surprise}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-snow-big" src={SnowImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.surpriseInfo1}</p>
                        <p className="report-text">{i18n.report.surpriseInfo2}</p>
                    </div>
                </div>
            </div>
            <div className="report-table-border"></div>
            <div className="report-table-tr">
                <div className="report-table-tr-tit">
                    <div className="report-table-td-first">
                        <div className="report-table-td-title">{data.sadness}</div>
                        <div className="report-table-td-subtitle">{i18n.report.sadness}</div>
                    </div>
                    <div className="report-table-td">
                        <img className="img-water-big" src={WaterImg} />
                    </div>
                </div>
                <div className="report-table-tr report-table-tr-last">
                    <div className="report-table-td">
                        <p className="report-text">{i18n.report.sadnessInfo1}</p>
                        <p className="report-text">{i18n.report.sadnessInfo2}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
